import { faCircleInfo } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@mui/material";

import { mapRoleIdToRole } from "../team/TeamManagement/utils";

const formatRoleCounts = (billableRoleCounts) =>
  (billableRoleCounts ?? [])
    .map(({ roleId, count }) => `${count} ${mapRoleIdToRole(roleId)}`)
    .join(", ");

/** Billed / Not billed status for a team row, with billable role counts on hover or focus. */
export const TeamBillingCell = ({
  isBillable,
  billableRoleCounts,
}) => {
  // Teams from the userTeams fallback carry no isBillable.
  if (isBillable == null) {
    return <span data-testid="team-billing-cell" />;
  }

  const popover = (
    <div data-testid="team-billing-popover">
      {isBillable ? (
        <>
          <p>{formatRoleCounts(billableRoleCounts)}</p>
          <p className="text-secondary">
            Free-plan and deactivated members aren&apos;t counted.
          </p>
        </>
      ) : (
        <p>No active DVM or Locum on a paid plan</p>
      )}
    </div>
  );

  return (
    <span data-testid="team-billing-cell">
      <Tooltip
        arrow
        placement="top"
        title={popover}
        slotProps={{
          tooltip: {
            className:
              "bg-primary! text-primary! border! border-primary! shadow-primary! rounded-standard! p-sm! text-sm!",
          },
          arrow: {
            className:
              "before:bg-primary! before:border! before:border-primary!",
          },
        }}
      >
        <span
          tabIndex={0}
          className={`inline-flex items-center gap-xs text-sm ${
            isBillable ? "text-success" : "text-secondary"
          }`}
        >
          <span
            aria-hidden
            className="size-2 rounded-full bg-current"
          />
          <span data-testid="team-billing-status">
            {isBillable ? "Billed" : "Not billed"}
          </span>
          <FontAwesomeIcon
            icon={faCircleInfo}
            size="xs"
            className="text-secondary"
          />
        </span>
      </Tooltip>
    </span>
  );
};
